import type { DesignPersonalizationContext, DesignPersonalizationImage } from '@vp/personalization-types'

export const designPersonalizationContextSelector = (state: State.GlobalState): DesignPersonalizationContext =>
  state.designPersonalization.designPersonalizationContext

export const designPersonalizationContextIdSelector = (state: State.GlobalState): string | undefined =>
  state.designPersonalization.designPersonalizationContextId

export const dpcsLoadingSelector = (state: State.GlobalState): boolean => state.designPersonalization.dpcsLoading

export const imageAppliedSelector = (state: State.GlobalState): boolean =>
  (state.designPersonalization.designPersonalizationContext?.images && state.designPersonalization.designPersonalizationContext?.images.length > 0) ?? false

export const logoAppliedSelector = (state: State.GlobalState): boolean =>
  state.designPersonalization.designPersonalizationContext?.images?.some((image: DesignPersonalizationImage) => image?.purpose === 'logo') || false

export const photoAppliedSelector = (state: State.GlobalState): boolean =>
  state.designPersonalization.designPersonalizationContext?.images?.some((image: DesignPersonalizationImage) => image?.purpose === 'photo') || false

export const textAppliedSelector = (state: State.GlobalState): boolean =>
  (state.designPersonalization.designPersonalizationContext?.text && state.designPersonalization.designPersonalizationContext?.text.length > 0) ?? false
